'use client';

import type { JSX } from 'react';
import React from 'react';
import classNames from 'classnames';

const SuspenseFallbackComponent = ({
  fitToContainer,
  fixedPosition
}: {
  fitToContainer?: boolean;
  fixedPosition?: boolean;
}): JSX.Element => {
  return (
    <div
      className={classNames('suspense-fallback', {
        'suspense-fallback--fit': fitToContainer,
        'suspense-fallback--fixed': fixedPosition
      })}
    >
      <div className="suspense-fallback__content"></div>
    </div>
  );
};

export default SuspenseFallbackComponent;
